import request from '#/utils/request';
import { withFmsActor } from '#/api/fmsMgmt/fmsActorConfig';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { toPaymentRequestWriteBody } from './serialize';

/**
 * PATCH `/fms/payment-requests/{id}`。
 * 僅 DRAFT／RETURNED；body 同 create＋updatedAt。
 */
export async function updatePaymentRequest(id, payload) {
  const { data: raw } = await request.patch(
    `/fms/payment-requests/${id}`,
    toPaymentRequestWriteBody(payload),
    withFmsActor(),
  );
  return parseVer4DetailResponse(raw);
}
